import assetLocationsService from "../../../../services/assetService/assetLocationsService";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { CACHE_KEY_ASSETLOCATIONS } from "../../../../utils/constants";
import { AssetLocationInterface } from "../../../../models/AssetModel/AssetLocation";

interface DeleteAssLocationContext {
  previousAssLocations: AssetLocationInterface[];
  deletedAssLocation: AssetLocationInterface | undefined;
}

const useDeleteAssetLocation = (page: number, pageSize: number) => {
  const queryClient = useQueryClient();

  return useMutation<
    void, // No return data after deletion
    Error,
    string, // ID of the ticket to delete
    DeleteAssLocationContext
  >({
    mutationFn: assetLocationsService.Remove, // Remove should take a string ID

    onMutate: (assLocationId: string) => {
      const previousAssLocations =
        queryClient.getQueryData<AssetLocationInterface[]>([
          CACHE_KEY_ASSETLOCATIONS,
          page,
          pageSize,
        ]) || [];

      // Optimistically update the cache
      queryClient.setQueryData<AssetLocationInterface[]>(
        [CACHE_KEY_ASSETLOCATIONS, page, pageSize],
        previousAssLocations.filter(
          (assLocation) => assLocation.id !== assLocationId
        ) // Use assLocationId to filter
      );

      return {
        previousAssLocations,
        deletedAssLocation: previousAssLocations.find(
          (assLocation) => assLocation.id === assLocationId
        ),
      };
    },

    onError: (error, assLocationId, context) => {
      if (!context) return;

      // Rollback to the previous state in case of error
      queryClient.setQueryData<AssetLocationInterface[]>(
        [CACHE_KEY_ASSETLOCATIONS, page, pageSize],
        context.previousAssLocations
      );
    },

    onSuccess: () => {
      // Optionally, you could perform additional actions on success
      // For example, invalidating queries or updating other parts of the state
    },
  });
};

export default useDeleteAssetLocation;
